import React, { Component } from 'react';
import { ButtonPrimary, Button } from 'components/buttons';
import { getLiteral } from 'utils/getLiteral';
import { ArrowBack } from 'components/SvgIcons';
import './style.scss';

class Steps extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.setSteps(React.Children.forEach.length);
    }

    handleClickPrev = () => {
        this.props.onClickPrev();
    };

    handleClickNext = () => {
        this.props.onClickNext();
    };

    handleClickCancel = () => {
        this.props.onClickCancel();
    };

    renderButton(type, classes, literal, onClick, icon) {
        if (literal && type === 'primary') {
            return (
                <ButtonPrimary classes={classes} onClick={onClick}>
                    {getLiteral(literal)}
                </ButtonPrimary>
            );
        } else if (literal && type === 'cancel') {
            return (
                <Button classes={classes} onClick={onClick}>
                    {getLiteral(literal)}
                    {icon ? <div className="icon-back">{icon}</div> : null}
                </Button>
            );
        } else {
            return null;
        }
    }

    render() {
        const { stage, prevBtnTxt, nextBtnTxt, cancelBtnTxt } = this.props;
        const childrenCount = React.Children.forEach.length;
        const children = React.Children.map(this.props.children, (child) => {
            if (!child) return null;
            return stage === child.props.num && <div>{child}</div>;
        });
        let currentPrevBtnTxt, currentNextBtnTxt;
        if (prevBtnTxt) {
            if (Array.isArray(prevBtnTxt)) {
                currentPrevBtnTxt = prevBtnTxt[stage - 1];
            } else {
                currentPrevBtnTxt = prevBtnTxt;
            }
        } else {
            currentPrevBtnTxt = 'action_back';
        }

        if (nextBtnTxt) {
            if (Array.isArray(prevBtnTxt)) {
                currentNextBtnTxt = nextBtnTxt[stage - 1];
            } else {
                currentNextBtnTxt = nextBtnTxt;
            }
        } else if (stage < childrenCount) {
            currentNextBtnTxt = 'action_next';
        } else {
            currentNextBtnTxt = 'action_end';
        }

        return (
            <div className="steps-container">
                {children}
                <div className="step-buttons-container">
                    {this.renderButton(
                        'cancel',
                        ['prev-btn'],
                        currentPrevBtnTxt,
                        this.handleClickPrev,
                        <ArrowBack />,
                    )}
                    {this.renderButton(
                        'primary',
                        ['next-btn'],
                        currentNextBtnTxt,
                        this.handleClickNext,
                        null,
                    )}
                    {this.renderButton(
                        'cancel',
                        ['cancel-btn'],
                        cancelBtnTxt,
                        this.handleClickCancel,
                        null,
                    )}
                </div>
            </div>
        );
    }
}

export default Steps;
